import React, { useCallback, useState, useContext, useMemo, useEffect } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import { Stopwatch } from 'hooked-react-stopwatch'
import { Button, ButtonGroup, Card, HTMLTable, Tag } from '@blueprintjs/core'
// import 'hooked-react-stopwatch/css/style.css'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import { css as classname } from 'emotion'
import { truncateDefault } from '../../../helper/functions'
import { defer } from 'lodash'
import { Trans, useTranslation } from 'react-i18next'

export let startStopWatch = () => false
export let pauseStopWatch = () => false
export let resetStopWatch = () => false
export function CourseStatusAddOn () {
  const context = useContext(GlobalContext)

  const [toggleStart, setToggleStart] = useState(globalOnDemandVars.stopwatchClearTime())
  const [togglePause, setTogglePause] = useState(!globalOnDemandVars.stopwatchClearTime() && (globalOnDemandVars.stopwatchTime().milliseconds || globalOnDemandVars.stopwatchTime().seconds || globalOnDemandVars.stopwatchTime().minutes || globalOnDemandVars.stopwatchTime().hours))

  const RenderControlComp = useCallback(
    ({
      startHandler,
      pauseHandler,
      resetHandler,
      getTime
    }) => {
      const onStart = () => {
        startHandler()
        setToggleStart(true)
        setTogglePause(false)
      }
      const onPause = () => {
        pauseHandler()
        setTogglePause(true)
        setToggleStart(false)
      }
      const onReset = () => {
        // const time = getTime()
        resetHandler()
        setTogglePause(false)
        setToggleStart(false)
      }

      startStopWatch = () => {
        startHandler()
      }
      pauseStopWatch = () => {
        pauseHandler()
      }
      resetStopWatch = () => {
        resetHandler()
        clearInterval(globalOnDemandVars.stopwatchClearTime())
      }

      return (
        <ButtonGroup css={css`margin: 0 auto 0 auto;`}>
          <Button onClick={onStart} icon='play' intent={toggleStart ? 'primary' : null} />
          <Button onClick={onPause} icon='pause' intent={togglePause ? 'primary' : null} />
          <Button onClick={onReset} icon='stop' />
        </ButtonGroup>
      )
    }
    ,
    [togglePause, toggleStart]
  )

  const { t } = useTranslation()

  return useMemo(() => (
    <div css={css`
& .bp3-card {
  padding: 10px;
  margin: 12px 4px;
}
`}>
      <Card css={css`text-align: center;`}>
        <b>{t('Running the Course for')}</b>
        <Stopwatch timeContainerClassName={classname`font-size: 30px; margin: 0 auto 0 auto;`}
          hideMilliseconds RenderControlComp={RenderControlComp} GlobalContext={GlobalContext}
          setTime={globalOnDemandVars.set_stopwatchTime}
          globalClearTime={globalOnDemandVars.stopwatchClearTime}
          setGlobalClearTime={globalOnDemandVars.set_stopwatchClearTime} />
      </Card>
      <Card>
        <HTMLTable condensed bordered>
          <tbody>
            <tr>
              <td><b>{t('Total Synapses')}</b></td>
              <td>{(context.courseStatus.totalSynapses || 0).toFixed(0)}</td>
            </tr>
            <tr>
              <td><b>{t('Target Synapses')}</b></td>
              <td>{(context.courseStatus.targetSynapses || 0).toFixed(0)}</td>
            </tr>
            <tr>
              <td><b>{t('Formed Synapses')}</b></td>
              <td>{(context.courseStatus.formedSynapses || 0).toFixed(0)}</td>
            </tr>
            <tr>
              <td><b>{t('Percentage')}</b></td>
              <td>{(((context.courseStatus.formedSynapses / context.courseStatus.targetSynapses) * 100) || 0).toFixed(1) + '%'}</td>
            </tr>
          </tbody>
        </HTMLTable>
        Or
        <HTMLTable condensed bordered>
          <tbody>
            <tr>
              <td><b>{t('Target Notes')}</b></td>
              <td>{(context.courseStatus.targetNotes || 0)}</td>
            </tr>
            <tr>
              <td><b>{t('Completed Notes')}</b></td>
              <td>{(context.courseStatus.completedNotes || 0)}</td>
            </tr>
            <tr>
              <td><b>{t('Percentage')}</b></td>
              <td>{(((context.courseStatus.completedNotes / context.courseStatus.targetNotes) * 100) || 0).toFixed(1) + '%'}</td>
            </tr>
          </tbody>
        </HTMLTable>
      </Card>
      <Card>
        <div css={css`text-align: center;`}><b>{t('In This Course')}</b></div>
        {((context.courseStatus.targetNodes && context.courseStatus.targetNodes.length) || (context.courseStatus.skippedNodes && context.courseStatus.skippedNodes.length) || (context.courseStatus.thoroughNodes && context.courseStatus.thoroughNodes.length))
          ? (<HTMLTable condensed bordered>
            <tbody>
              {context.courseStatus.targetNodes && context.courseStatus.targetNodes.length && (<>
                <tr>
                  <th>{t('Target')}</th>
                </tr>
                <tr>
                  <td>{context.courseStatus.targetNodes.map((nodeTitle, i) => (
                    <Tag key={i} minimal title={nodeTitle}>{truncateDefault(nodeTitle, true)}</Tag>))}</td>
                </tr>
              </>)}
              {context.courseStatus.skippedNodes && context.courseStatus.skippedNodes.length && (<>
                <tr>
                  <th>{t('Skipped')}</th>
                </tr>
                <tr>
                  <td>{context.courseStatus.skippedNodes.map((nodeTitle, i) => (
                    <Tag key={i} minimal title={nodeTitle}>{truncateDefault(nodeTitle, true)}</Tag>))}</td>
                </tr>
              </>)}
              {context.courseStatus.thoroughNodes && context.courseStatus.thoroughNodes.length && (<>
                <tr>
                  <th>{t('Being Thoroughly Reviewed')}</th>
                </tr>
                <tr>
                  <td>{context.courseStatus.thoroughNodes.map((nodeTitle, i) => (
                    <Tag key={i} minimal title={nodeTitle}>{truncateDefault(nodeTitle, true)}</Tag>))}</td>
                </tr>
              </>)}
            </tbody>
          </HTMLTable>) : <span>{t('You are running this course with default settings')}</span>}
      </Card>
    </div>
  ), [RenderControlComp, context.courseStatus.completedNotes, context.courseStatus.formedSynapses, context.courseStatus.skippedNodes, context.courseStatus.targetNodes, context.courseStatus.targetNotes, context.courseStatus.targetSynapses, context.courseStatus.thoroughNodes, context.courseStatus.totalSynapses, t])
}

const CourseStatusAddOnBoxClass = new BoxClass(CourseStatusAddOn, 'Course State', null, 1, { order: 8, onlyForTheseLocations: ['/memorizing', '/memorizingEnter'] })

export default CourseStatusAddOnBoxClass
